import { render, staticRenderFns } from "./edit_quote.vue?vue&type=template&id=4d254f96&scoped=true"
import script from "./edit_quote.vue?vue&type=script&lang=js"
export * from "./edit_quote.vue?vue&type=script&lang=js"
import style0 from "./edit_quote.vue?vue&type=style&index=0&id=4d254f96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d254f96",
  null
  
)

export default component.exports